import {
  Box,
  Button,
  Chip,
  createStyles,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import {Pagination} from "@material-ui/lab";
import {makeStyles, withStyles} from "@material-ui/styles";
import {useAppDispatch, useAppSelector} from "app/hooks";
import {selectInfoLogin} from "features/Auth/authSlice";
import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {dateTimeToFormatYYYY} from "utils/dateTimeFormat";
import {
  fetchListTestOldStudent,
  SelectFilterListExamStudent,
  SelectListTestOldStudent,
  selectLoadingListExamStudent,
  setFilterListExam,
} from "../../listExamStudentSlice";
import {useTranslation} from "react-i18next";
import LOADING from "assets/img/loading.gif";
import EmptyComponent from "components/Empty";
import moment from "moment";
import HistoryIcon from "@material-ui/icons/History";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CardGiftcardIcon from "@material-ui/icons/CardGiftcard";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";

export default function ListExamHistory() {
  const useStyles = makeStyles((theme: Theme) => ({
    container: {
      padding: "30px 24px",
      maxWidth: 1400,
      margin: "0 auto",
      overflow: "hidden",
      [theme.breakpoints?.down("md")]: {
        padding: "20px 16px",
      },
      [theme.breakpoints?.down("sm")]: {
        padding: "16px 10px",
      },
    },
    headerBanner: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 24,
      flexWrap: "wrap",
      gap: 16,
    },
    headerTitleGroup: {
      display: "flex",
      alignItems: "center",
      gap: 14,
    },
    headerIconPill: {
      width: 48,
      height: 48,
      borderRadius: 14,
      background: "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#FFFFFF",
      boxShadow: "0 6px 18px rgba(37, 99, 235, 0.3)",
    },
    title: {
      color: "#0F172A",
      fontSize: "1.35rem",
      fontWeight: 800,
      letterSpacing: "0.02em",
      [theme.breakpoints?.down("sm")]: {
        fontSize: "1.1rem",
      },
    },
    subtitle: {
      fontSize: "0.85rem",
      color: "#64748B",
      fontWeight: 500,
    },
    summaryGrid: {
      marginBottom: 40,
    },
    summaryCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 18,
      padding: "12px 20px",
      border: "1px solid #E2E8F0",
      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.04)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      transition: "all 0.3s ease",
      "&:hover": {
        transform: "translateY(-3px)",
        boxShadow: "0 14px 28px rgba(0, 0, 0, 0.08)",
      },
    },
    loading: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      "& >img": {
        width: 100,
        height: 100,
      },
    },
    container_table: {
      borderRadius: 20,
      boxShadow: "0 10px 30px -5px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.03)",
      border: "1px solid #E2E8F0",
      overflowX: "auto",
      "& .MuiTable-root": {
        minWidth: 700,
      },
      "& .MuiTableRow-root:nth-of-type(even)": {
        backgroundColor: "#F8FAFC",
      },
    },
    mobileCard: {
      backgroundColor: "#FFFFFF",
      borderRadius: 16,
      padding: "16px 18px",
      border: "1px solid #E2E8F0",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
      transition: "all 0.25s ease",
      "&:active": {
        transform: "scale(0.98)",
        backgroundColor: "#F8FAFC",
      },
    },
    rowClickable: {
      cursor: "pointer",
      transition: "background-color 0.2s ease",
      "&:hover": {
        backgroundColor: "#F1F5F9 !important",
      },
    },
    btn_detail: {
      background: "linear-gradient(135deg, #2563EB 0%, #1D4ED8 100%)",
      borderRadius: 10,
      color: "#FFFFFF",
      padding: "6px 16px",
      fontWeight: 700,
      fontSize: "0.825rem",
      textTransform: "none",
      boxShadow: "0 4px 12px rgba(37, 99, 235, 0.25)",
      transition: "all 0.25s ease",
      "&:hover": {
        background: "linear-gradient(135deg, #1D4ED8 0%, #1E40AF 100%)",
        boxShadow: "0 6px 16px rgba(37, 99, 235, 0.4)",
      },
      [theme.breakpoints?.down("sm")]: {
        padding: "4px 8px",
        fontSize: "0.75rem",
        minWidth: 40,
      },
    },
  }));

  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        padding: "14px 16px",
        background: "linear-gradient(135deg, #0F172A 0%, #1E293B 100%)",
        color: "#FFFFFF",
        fontSize: 13,
        fontWeight: 800,
        letterSpacing: "0.03em",
        borderRight: "1px solid rgba(255, 255, 255, 0.1)",
        borderBottom: "none",
        textTransform: "uppercase",
        [theme.breakpoints?.down("sm")]: {
          fontSize: 10,
          padding: "10px 6px",
        },
      },
      body: {
        padding: "14px 16px",
        fontSize: 13,
        fontWeight: 500,
        color: "#1E293B",
        borderRight: "1px solid #F1F5F9",
        borderBottom: "1px solid #F1F5F9",
        [theme.breakpoints?.down("sm")]: {
          fontSize: 10,
          padding: "10px 6px",
        },
      },
    })
  )(TableCell);

  const {t} = useTranslation();
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const filter = useAppSelector(SelectFilterListExamStudent);
  const listTest = useAppSelector(SelectListTestOldStudent);
  const loading = useAppSelector(selectLoadingListExamStudent);
  const navigate = useNavigate();
  const infoLogin = useAppSelector(selectInfoLogin);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints?.down("sm"));

  useEffect(() => {
    dispatch(fetchListTestOldStudent({...filter}));
  }, [dispatch, filter, infoLogin]);

  const handleChangePage = (page: number) => {
    dispatch(
      setFilterListExam({
        ...filter,
        page: page - 1,
      })
    );
  };

  const handleRowClick = (test: any) => {
    navigate(`/test/detail/${test?.id}`, {
      state: {
        examId: test?.examId,
        duration: test?.duration,
      },
    });
  };

  const renderRatingChip = (pct: number) => {
    if (pct < 50) {
      return (
        <Chip
          label={t("point.yeu")}
          size="small"
          style={{
            backgroundColor: "#FEF2F2",
            color: "#DC2626",
            fontWeight: 800,
            border: "1px solid #FECACA",
          }}
        />
      );
    } else if (pct < 65) {
      return (
        <Chip
          label={t("point.trungbinh")}
          size="small"
          style={{
            backgroundColor: "#F1F5F9",
            color: "#475569",
            fontWeight: 800,
            border: "1px solid #CBD5E1",
          }}
        />
      );
    } else if (pct < 80) {
      return (
        <Chip
          label={t("point.kha")}
          size="small"
          style={{
            backgroundColor: "#EFF6FF",
            color: "#2563EB",
            fontWeight: 800,
            border: "1px solid #BFDBFE",
          }}
        />
      );
    } else if (pct < 100) {
      return (
        <Chip
          label={t("point.gioi")}
          size="small"
          style={{
            backgroundColor: "#F3E8FF",
            color: "#7C3AED",
            fontWeight: 800,
            border: "1px solid #DDD6FE",
          }}
        />
      );
    } else {
      return (
        <Chip
          label={t("point.thukhoa")}
          size="small"
          style={{
            backgroundColor: "#FEF3C7",
            color: "#D97706",
            fontWeight: 800,
            border: "1px solid #FDE68A",
          }}
        />
      );
    }
  };

  const tableData: any[] = listTest?.submissionDetails?.content || [];
  const totalExams = listTest?.submissionDetails?.totalElements || tableData.length;

  return loading ? (
    <Box className={classes.loading}>
      <img src={LOADING} alt="LOADING" />
    </Box>
  ) : (
    <Box className={classes.container}>
      {/* Header Banner */}
      <Box className={classes.headerBanner}>
        <Box className={classes.headerTitleGroup}>
          <Box className={classes.headerIconPill}>
            <HistoryIcon style={{fontSize: 26}} />
          </Box>
          <Box>
            <Typography className={classes.title}>{t("listexam.danhsachbaithicu")}</Typography>
            <Typography className={classes.subtitle}>
              Xem lại lịch sử kết quả, chi tiết đáp án và điểm số bài thi
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Summary Score Cards */}
      {totalExams > 0 && (
        <Grid
          container
          spacing={isMobile ? 2 : 3}
          alignItems="stretch"
          className={classes.summaryGrid}
        >
          <Grid item xs={12} sm={6}>
            <Box
              className={classes.summaryCard}
              style={{
                background: "linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%)",
                borderColor: "#BFDBFE",
                height: "100%",
                minHeight: 80,
              }}
            >
              <Box>
                <Typography
                  style={{
                    fontSize: "0.775rem",
                    color: "#1D4ED8",
                    fontWeight: 800,
                    textTransform: "uppercase",
                    letterSpacing: "0.04em",
                    marginBottom: 6,
                  }}
                >
                  TỔNG SỐ BÀI THI ĐÃ HOÀN THÀNH
                </Typography>
                <Box style={{display: "flex", alignItems: "baseline", gap: 8}}>
                  <Typography
                    style={{
                      fontSize: "2.0rem",
                      fontWeight: 900,
                      color: "#2563EB",
                      lineHeight: 1,
                    }}
                  >
                    {totalExams}
                  </Typography>
                  <Typography style={{fontSize: "0.95rem", fontWeight: 700, color: "#3B82F6"}}>
                    bài đã hoàn thành
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8}}
              >
                <EmojiEventsIcon style={{color: "#2563EB", fontSize: 32}} />
                <Chip
                  label="Lịch sử làm bài"
                  size="small"
                  style={{
                    backgroundColor: "#DBEAFE",
                    color: "#1D4ED8",
                    fontWeight: 800,
                    border: "1px solid #93C5FD",
                  }}
                />
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box
              className={classes.summaryCard}
              style={{
                background: "linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%)",
                borderColor: "#FCD34D",
                height: "100%",
                minHeight: 80,
              }}
            >
              <Box>
                <Typography
                  style={{
                    fontSize: "0.775rem",
                    color: "#B45309",
                    fontWeight: 800,
                    textTransform: "uppercase",
                    letterSpacing: "0.04em",
                    marginBottom: 6,
                  }}
                >
                  LƯU TRỮ ĐÁP ÁN & KẾT QUẢ
                </Typography>
                <Box style={{display: "flex", alignItems: "baseline", gap: 8}}>
                  <Typography
                    style={{
                      fontSize: "2.0rem",
                      fontWeight: 900,
                      color: "#D97706",
                      lineHeight: 1,
                    }}
                  >
                    100%
                  </Typography>
                  <Typography style={{fontSize: "0.95rem", fontWeight: 700, color: "#B45309"}}>
                    tự động lưu trữ
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 8}}
              >
                <CardGiftcardIcon style={{color: "#D97706", fontSize: 32}} />
                <Chip
                  label="Xem chi tiết đáp án"
                  size="small"
                  style={{
                    backgroundColor: "#FDE68A",
                    color: "#B45309",
                    fontWeight: 800,
                    border: "1px solid #FCD34D",
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}

      {/* Table Section */}
      <Box>
        {tableData.length > 0 ? (
          isMobile ? (
            <Box style={{display: "flex", flexDirection: "column", gap: 16}}>
              {tableData.map((test: any, index: number) => {
                const pct = test.maxPoint > 0 ? (test.point / test.maxPoint) * 100 : 0;
                const forced = test.exam?.isForcedToDisplayAnswers;

                const isAnswerAvailable =
                  forced == null
                    ? !!(
                        test.exam?.publishAnswerDate &&
                        moment.utc(test.exam.publishAnswerDate).unix() -
                          moment.utc(new Date()).unix() <
                          0 &&
                        (!test.exam?.hiddenAnswerDate ||
                          moment.utc(test.exam.hiddenAnswerDate).unix() -
                            moment.utc(new Date()).unix() >
                            0)
                      )
                    : !!forced;
                const clickable = isAnswerAvailable;

                return (
                  <Box
                    key={test.id}
                    onClick={() => clickable && handleRowClick(test)}
                    className={classes.mobileCard}
                    style={{
                      cursor: clickable ? "pointer" : "default",
                    }}
                  >
                    {/* Top Row: Date & Rating Badge */}
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: 12,
                      }}
                    >
                      <Typography style={{fontSize: "0.85rem", fontWeight: 700, color: "#64748B"}}>
                        {dateTimeToFormatYYYY(test?.startTime)}
                      </Typography>
                      {renderRatingChip(pct)}
                    </Box>

                    {/* Middle Row: Exam Title */}
                    <Typography
                      style={{
                        fontWeight: 800,
                        color: "#1E293B",
                        fontSize: "1.0rem",
                        marginBottom: 12,
                      }}
                    >
                      {test?.exam?.examTitle}
                    </Typography>

                    {/* Score / Points Row */}
                    <Box style={{display: "flex", alignItems: "center", gap: 8, marginBottom: 12}}>
                      <Typography style={{fontSize: "0.85rem", fontWeight: 700, color: "#64748B"}}>
                        Điểm số:
                      </Typography>
                      <Typography style={{fontSize: "1.1rem", fontWeight: 900, color: "#2563EB"}}>
                        {test.point.toFixed(2)}
                      </Typography>
                    </Box>

                    {/* Bottom Row: Prize & Action Button */}
                    <Box
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingTop: 10,
                        borderTop: "1px solid #F1F5F9",
                      }}
                    >
                      <Box>
                        {test?.exam?.prize?.name ? (
                          <Box
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 4,
                              color: "#D97706",
                            }}
                          >
                            <CardGiftcardIcon style={{fontSize: 16}} />
                            <Typography style={{fontWeight: 700, fontSize: "0.8rem"}}>
                              {test.exam.prize.name}
                            </Typography>
                          </Box>
                        ) : (
                          <Typography style={{color: "#94A3B8", fontSize: "0.8rem"}}>
                            Không có phần thưởng
                          </Typography>
                        )}
                      </Box>
                      {isAnswerAvailable ? (
                        <Button
                          size="small"
                          className={classes.btn_detail}
                          startIcon={<VisibilityIcon />}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRowClick(test);
                          }}
                        >
                          {t("button.detail")}
                        </Button>
                      ) : (
                        <Typography style={{color: "#94A3B8", fontSize: "0.8rem"}}>
                          Không có đáp án
                        </Typography>
                      )}
                    </Box>
                  </Box>
                );
              })}
            </Box>
          ) : (
            <TableContainer component={Paper} className={classes.container_table}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center" width="70px">
                      {t("listexam.stt")}
                    </StyledTableCell>
                    <StyledTableCell align="center" width="130px">
                      {t("listexam.ngaythi")}
                    </StyledTableCell>
                    <StyledTableCell align="left">{t("listexam.tieudebaithi")}</StyledTableCell>
                    <StyledTableCell align="center" width="180px">
                      {t("listexam.phanthuong")}
                    </StyledTableCell>
                    <StyledTableCell align="center" width="100px">
                      {t("listexam.diem")}
                    </StyledTableCell>
                    <StyledTableCell align="center" width="130px">
                      {t("listexam.xeploai")}
                    </StyledTableCell>
                    <StyledTableCell align="center" width="160px">
                      {t("listexam.thaotac")}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {tableData.map((test: any, index: number) => {
                    const pct = test.maxPoint > 0 ? (test.point / test.maxPoint) * 100 : 0;
                    const forced = test.exam?.isForcedToDisplayAnswers;
                    const isAnswerAvailable =
                      forced == null
                        ? !!(
                            test.exam?.publishAnswerDate &&
                            moment.utc(test.exam.publishAnswerDate).unix() -
                              moment.utc(new Date()).unix() <
                              0 &&
                            (!test.exam?.hiddenAnswerDate ||
                              moment.utc(test.exam.hiddenAnswerDate).unix() -
                                moment.utc(new Date()).unix() >
                                0)
                          )
                        : !!forced;
                    const clickable = isAnswerAvailable;

                    return (
                      <TableRow
                        key={test.id}
                        onClick={() => clickable && handleRowClick(test)}
                        className={clickable ? classes.rowClickable : ""}
                      >
                        <StyledTableCell align="center" style={{fontWeight: 700, color: "#64748B"}}>
                          {listTest?.submissionDetails?.size * listTest?.submissionDetails?.number +
                            index +
                            1}
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          {dateTimeToFormatYYYY(test?.startTime)}
                        </StyledTableCell>

                        <StyledTableCell align="left" style={{fontWeight: 700}}>
                          {test?.exam?.examTitle}
                        </StyledTableCell>

                        <StyledTableCell align="center" style={{color: "#D97706", fontWeight: 700}}>
                          {test?.exam?.prize?.name || "-"}
                        </StyledTableCell>

                        <StyledTableCell align="center">
                          <Typography
                            style={{fontSize: "1.1rem", fontWeight: 900, color: "#2563EB"}}
                          >
                            {test.point.toFixed(2)}
                          </Typography>
                        </StyledTableCell>

                        <StyledTableCell align="center">{renderRatingChip(pct)}</StyledTableCell>

                        <StyledTableCell align="center">
                          {isAnswerAvailable ? (
                            <Button
                              className={classes.btn_detail}
                              startIcon={<VisibilityIcon />}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRowClick(test);
                              }}
                            >
                              {t("button.detail")}
                            </Button>
                          ) : (
                            <Typography style={{color: "#94A3B8", fontSize: "0.85rem"}}>
                              -
                            </Typography>
                          )}
                        </StyledTableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )
        ) : (
          <Box py={4}>
            <EmptyComponent isBorder={false} description={t("listexam.chuacobaithicu")} />
          </Box>
        )}

        {listTest?.submissionDetails?.totalPages > 0 && (
          <Box mt={3} display="flex" justifyContent="center" mb={3}>
            <Pagination
              count={Math.ceil(
                listTest?.submissionDetails?.totalElements / listTest?.submissionDetails?.size
              )}
              page={listTest?.submissionDetails?.number + 1}
              variant="outlined"
              color="primary"
              shape="rounded"
              onChange={(e, page) => handleChangePage(page)}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}
